<script setup>
import { nextTick, onMounted, watch } from 'vue'
import { t, langRef, languageList, languageShow, setLanguage } from '@/i18n'
import { useRoute, useRouter } from 'vue-router'
import { isAuthRef } from '@/model/user'
import WiDialog from "./components/WiDialog/dialog.vue"

const route = useRoute()
const router = useRouter()

const APPNAME = process.env.VUE_APP_NAME

watch(()=> isAuthRef.value, (newx)=> {
  if(!newx && route.meta.loginRequired) {
    router.replace({
      path: '/login',
      query: {
        next: encodeURI(route.fullPath)
      }
    })
  }
}, {immediate: true, deep: true})


onMounted(()=> {
  nextTick(()=> {
    document.title = APPNAME
  })
})
</script>

<template>
  <div id="app" class="min-h-screen flex flex-col">
    <router-view class="grow" />
    <WiDialog></WiDialog>
    <nut-popup v-model:visible="languageShow" :style="{
      backgroundColor: 'var(--bg-popup)',
      color: 'var(--text-popup)',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
    }" position="bottom">
        <div class="px-ctx py-4">
          <h5 class="mb-2.5 text-base text-center font-bold">
            <span>{{ t('语言') }}</span>
          </h5>
          <ul class="-mx-ctx px-ctx py-2.5 max-h-[60vh] overflow-y-auto">
            <template v-for="item,index in languageList" :key="index">
              <li @click="setLanguage(item)" :class="item.value==langRef?'bg-theme/[0.08] text-theme':''" class="px-2.5 py-4 rounded cursor-pointer flex items-center">
                <p class="flex-1 overflow-hidden text-sm font-bold">
                  <span>{{ item.label }}</span>
                </p>
                <svg v-if="item.value==langRef" class="w-3 h-3 ml-2 shrink-0" stroke="currentColor" stroke-width="4" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M43 11L16.875 37L5 25.1818" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </li>
            </template>
          </ul>
          <div class="w-full pb-safe"></div>
        </div>
    </nut-popup>
  </div>
</template>
<style>
body .h-screen {
    height: 100vh;
    height: calc(var(--vh) * 100);
}
body .min-h-screen {
    min-height: 100vh;
    min-height: calc(var(--vh) * 100);
}
</style>